import { z } from 'zod';

import { INVOICE_FILE_ROLES } from './constants';

export const zodInvoiceFileByRoleEndpointSchema = z.tuple([
  z.literal('invoices'),
  z.uuid(),
  z.literal('file'),
]);

export const zodInvoiceFileByRoleSearchParamsSchema = z.object({
  role: z.enum(INVOICE_FILE_ROLES),
});
